export const formatoMiles = (valor) => {
  if (valor === null || valor === undefined || valor === '') { return valor; }
  const numero = Number(valor);
  if (Number.isNaN(numero)) { return valor; }
  return numero.toLocaleString('es-CL');
};
